import Vue from 'vue'
import VueRouter from 'vue-router'

import Library from '../views/library/Library.vue'
import Parts from '../views/library/parts/Parts.vue'
import PartDetails from '../views/PartDetails.vue'
import PartCategories from '../views/library/parts/PartCategories.vue'
import PartCategory from '../views/library/parts/PartCategory.vue'

import Prefabs from '../views/library/Prefabs.vue'
import Models from '../views/library/Models.vue'

import SignIn from '../views/SignIn.vue'
import Home from '../views/Home.vue'
import Project from '../views/Project.vue'
import Cart from '../views/Cart.vue'
import Load from '../views/Load.vue'
import PublicSaveFiles from '../views/PublicSaveFiles.vue'
import Open from '../views/Open.vue'
import Save from '../views/Save.vue'
import Checkout from '../views/Checkout.vue'
import Order from '../views/Order.vue'
import Pricing from '../views/Pricing.vue'
import PaymentSuccess from '../views/PaymentSuccess.vue'
import PaymentCanceled from '../views/PaymentCanceled.vue'
import Settings from '../views/Settings.vue'
import Shapes from '../views/Shapes.vue'
import OrderConfirmation from '../views/OrderConfirmation.vue'
import OrderHistory from '../views/OrderHistory.vue'
import OrderFromHistory from '../views/OrderFromHistory.vue'
import Tutorials from '../views/Tutorials.vue'
import Viewer from '../views/Viewer.vue'

import mixpanel from 'mixpanel-browser';

import store from '../store'

Vue.use(VueRouter)

const routes = [
  {
    path: '/library',
    name: 'Library',
    component: Library,
    children: [
      {
        path: '/parts',
        name: 'Parts',
        component: Parts,
        children: [
          {
            path: '/parts/categories/:category_parent+/:part_category/id/:part_id',
            name: 'MultiRelatedPartDetails',
            component: PartDetails,
            meta: { requiresAuth: false } 
          },
          {
            path: '/parts/categories/:part_category/id/:part_id',
            name: 'MultiRelatedPartDetails',
            component: PartDetails,
            meta: { requiresAuth: false } 
          },
          {
            path: '/parts/categories/:category_parent+/:part_category',
            name: 'PartCategory',
            component: PartCategories,
            meta: { requiresAuth: false, keepScrollPosition: true } 
          },
          {
            path: '/parts/categories/:part_category',
            name: 'PartCategory',
            component: PartCategories,
            meta: { requiresAuth: false, keepScrollPosition: true } 
          },
          {
            path: '/parts/categories/:part_category',
            name: 'PartCategory',
            component: PartCategories,
            meta: { requiresAuth: false, keepScrollPosition: true } 
          },
          {
            path: '/parts',
            alias: ['/parts/categories'],
            name: 'PartCategories',
            component: PartCategories,
            meta: { requiresAuth: false, keepScrollPosition: true } 
          },
          {
            path: '/parts/:part_id',
            redirect: '/part/:part_id'
          },
        ]
      }, {
        path: 'prefabs',
        name: 'Prefabs',
        component: Prefabs,
        meta: { requiresAuth: true } 
      }, {
        path: 'models',
        name: 'Models',
        component: Models,
        meta: { requiresAuth: true } 
      },
    ]
  },
  {
    path: '/part/:part_id',
    name: 'PartExact',
    component: PartDetails,
    meta: { requiresAuth: false } 
  },
  {
    path: '/checkout',
    name: 'Checkout',
    component: Checkout,
    meta: { requiresAuth: true } 
  },{
    path: '/order',
    name: 'Order',
    component: Order,
    meta: { requiresAuth: true } 
  },{
    path: '/order-confirmation',
    name: 'OrderConfirmation',
    component: OrderConfirmation,
    meta: { requiresAuth: true } 
  },{
    path: '/order-from-history',
    name: 'OrderFromHistory',
    component: OrderFromHistory,
    meta: { requiresAuth: true } 
  },{
    path: '/order-history',
    name: 'OrderHistory',
    component: OrderHistory,
    meta: { requiresAuth: true } 
  },{
    path: '/signin',
    name: 'SignIn',
    component: SignIn
  },{
    path: '/',
    alias: '/home',
    name: 'Home',
    component: Home,
    meta: { requiresAuth: false } //requiresMembership: true
  },{
    path: '/project/:project_id',
    name: 'Project',
    component: Project,
    meta: { requiresAuth: true } // requiresMembership: true
  },{
    path: '/template/:project_id',
    name: 'Template',
    component: Project,
    meta: { requiresAuth: false } // requiresMembership: true
  },{
    path: '/projects',
    alias: ['/load'],
    name: 'Load',
    component: Load,
    meta: { requiresAuth: true } // requiresMembership: true
  },{
    path: '/cart',
    name: 'Cart',
    component: Cart,
    meta: { requiresAuth: true } // requiresMembership: true
  },{
    path: '/templates/:category_parent+/:category',
    name: 'Templates',
    component: PublicSaveFiles,
    meta: { requiresAuth: false } 
  },{
    path: '/templates/:category',
    name: 'Templates',
    component: PublicSaveFiles,
    meta: { requiresAuth: false } 
  },{
    path: '/templates',
    name: 'Templates',
    component: PublicSaveFiles,
    meta: { requiresAuth: false } // requiresMembership: true
  },{
    path: '/open',
    name: 'Open',
    component: Open,
    meta: { requiresAuth: true } // requiresMembership: true
  },{
    path: '/save',
    name: 'Save',
    component: Save,
    meta: { requiresAuth: true } // requiresMembership: true
  },{
    path: '/pricing',
    name: 'Pricing',
    component: Pricing,
  },{
    path: '/payment-success',
    name: 'PaymentSuccess',
    component: PaymentSuccess,
  },{
    path: '/payment-canceled',
    name: 'PaymentCanceled',
    component: PaymentCanceled,
  },{
    path: '/settings',
    name: 'Settings',
    component: Settings,
    meta: { requiresAuth: true } 
  },{
    path: '/shapes',
    name: 'Shapes',
    component: Shapes,
    meta: { requiresAuth: false } 
  },{
    path: '/tutorials',
    name: 'Tutorials',
    component: Tutorials,
    meta: { requiresAuth: false } 
  },{
    path: '/viewer/:uid/:glb',
    name: 'Viewer',
    component: Viewer,
    meta: { requiresAuth: false } 
  }
]

const scrollPositions = {};

const router = new VueRouter({
  scrollBehavior(to, from) { 
    let scrollPosition = to.meta.keepScrollPosition && scrollPositions[to.fullPath] ? scrollPositions[to.fullPath] : 0
    scrollTo(scrollPosition);
  },
  routes,
})

const originalPush = router.push;
router.push = async function push(loc){
  try {
    return await originalPush.bind(this)(loc)
  } catch (e) {
    if (e?.name === 'NavigationDuplicated') {
      scrollTo(0);
    } else {
      throw e
    }
  }
}

function scrollTo(scrollPosition){
  const scrollPage = document.getElementById('scroll-page')
    if(scrollPage){
      document.getElementById("scroll-page").scrollTo(0, scrollPosition);
    }else{
      window.scroll(0, scrollPosition)
    }
}

router.beforeEach((to, from, next) => {
  const scrollPage = document.getElementById('scroll-page')
  if(from.fullPath != to.fullPath){
    if(scrollPage){
      scrollPositions[from.fullPath] = scrollPage.scrollTop;
    }else{
      scrollPositions[from.fullPath] = window.scrollY;
    }
  }
  return next()
})

router.beforeResolve((to, from, next) => {

  function goToPage(){
    mixpanel.track("Page View", {
      to: to.fullPath,
      from: from.fullPath,
    });
    store.dispatch('postMessage', "PageView:"+to.fullPath);
    next();
  }
  
  store.dispatch('auth/checkUserSignIn').then(response=>{  

    // var creationTime = new Date(response.metadata.creationTime);
    // var now = new Date();

    // var differenceInTime = now.getTime() - creationTime.getTime();
    // var differenceInDays = differenceInTime / (1000 * 3600 * 24);

    goToPage()
    // store.dispatch('auth/checkUserSubscription').then(response=>{  
    //   goToPage()
    // }).catch(response => {
    //   if(differenceInDays <= 30 && differenceInDays > 23 && store.get('show_trail_ending_msg')){
    //     store.commit('show_trail_ending_msg', false);
    //     store.commit('confirm', {
    //       title: "You have " + (30 - Math.ceil(differenceInDays)) + " days left in your free trial.",
    //       description: "Subscribe now to get unlimited access.",
    //       start_label: "Subscribe",
    //       stop_label: "Close",
    //       start: ()=>{
    //         router.push({name: 'Pricing'})
    //       },
    //     }, {root: true});
    //   }
  
    //   if(to.matched.some(record => record.meta.requiresMembership)){
    //     if(differenceInDays > 30){
    //       next({
    //         path: '/pricing'
    //       });
    //       store.commit('confirm', {
    //         title: "Your free trial has expired.",
    //         description: "We hope you have enjoyed your experience so far. Please subscribe to get unlimited access.",
    //         start_label: "Close",
    //         stop_label: "NONE",
    //       }, {root: true});
    //     }else{
    //       goToPage()
    //     }   
    //   }else{
    //     goToPage()
    //   }
    // })
  }).catch(e=>{
    if(to.matched.some(record => record.meta.requiresAuth)){
      next({
        path: '/signin?to='+to.name
      });
    }else{
      goToPage()
    }
  })
})

export default router
